import {ColorFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';

export const useColorFilterSection = ({
  activeFilters,
  data,
}: {
  activeFilters: Map<string, Array<string> | undefined>;
  data: ColorFilterSection;
}) => {
  const {colors, label, slug} = data;

  const normalizedColors = colors.map(({color, id, label, productCount}) => ({
    gradient:
      color?.$case === 'multiColors' ? color.multiColors.hexCodes : undefined,
    hex:
      color?.$case === 'simpleColor' ? color?.simpleColor?.hexCode : undefined,
    id,
    isLightColor:
      color?.$case === 'simpleColor' ? color?.simpleColor?.isLightColor : false,
    label,
    productCount,
  }));

  const activeSlugFilters = (activeFilters.get(slug) ?? []).filter(value =>
    colors.map(({id}) => String(id)).includes(value),
  );

  return {
    activeSlugFilters,
    label,
    normalizedColors,
    slug,
  };
};
